module.exports = __webpack_public_path__ + "static/media/search.9ae6f3fe.svg";